export const API_URL = {
  mock: '',
  dev: 'https://newc-dev.apigw.qa.91jkys.com/api/',
  qa: 'https://newc-qa.apigw.qa.91jkys.com/api/',
  pre: 'https://apigw.pre.91jkys.com/api/',
  pro: 'https://apigw.91jkys.com/api/'
};

export const STATIC_URL = {
  mock: 'http://static.qa.91jkys.com/',
  dev: 'http://static.qa.91jkys.com/',
  qa: 'http://static.qa.91jkys.com/',
  pre: 'https://static.pre.91jkys.com/',
  pro: 'https://static.91jkys.com/'
};

export const CALL_IOS_APP_DEEPLINK = {
  mock: 'https://deeplink.91jkys.com/zyhealthtest',
  dev: 'https://deeplink.91jkys.com/zyhealthtest',
  qa: 'https://deeplink.91jkys.com/zyhealthtest',
  pre: 'https://deeplink.91jkys.com/zyhealthpre',
  pro: 'https://deeplink.91jkys.com/zyhealth'
};

export const ANDROID_URL_SCHEME = 'zyhealth://zyhealth.com';
